import { HowDidYouHearAboutUsOptionInput } from '../../lib/types/models/how-did-you-hear-about-us-option/how-did-you-hear-about-us-option-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createHowDidYouHearAboutUs(data: HowDidYouHearAboutUsOptionInput) {
  return restApiClient.url(constructApiUrl(API.howDidYouHearAboutUs.create.url, null)).post(data)
}
